// src/utils/sanitizeId.js
export const sanitizeId = (id) => id.replace(/[^a-zA-Z0-9_-]/g, "");
